import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, MenuItem, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import deleteIcon from '../../assets/images/Delete_Icon.png'
import "./JobsTable.css";
import Project from '../../Items/Project';
import { Job } from '../../Items/Job';

import MmdService from "../../Services/MmdService";
import JobService from "../../Services/JobService";
import { useDispatch, useSelector } from 'react-redux';

interface JobsListProps {
  projects: Project[];
  setProjects: React.Dispatch<React.SetStateAction<Project[]>>;
}

const JobsList: React.FC<JobsListProps> = ({ projects, setProjects }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [globalError, setGlobalError] = useState<string>('');
  const businesses = useSelector((state: any) => state.Business.businesses || []);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);
        const jobsData: Job[] = await JobService.getJobs();
        
        const mappedProjects: Project[] = jobsData.map((job) => {
          console.log("האובייקט הגולמי מהשרת:", job);
          return {
            id: job.id,
            OrderingCompany: job.orderingCompany?.id?.toString() || '', 
            
            // 🛠️ שינוי כאן: תמיד מקבל "שרטוט" בלי קשר למה שחזר מהשרת
            workType: 'שרטוט', 
            
            price: job.price.toString(),
            fileRecovery: job.fileUpload || '',
            status: 'פתח קובץ',
            progress: null,
            completed: false,
            statusType: job.downloadUrl ? 'gray' : 'purple',
            fileObject: null,
            error: null,
            downloadUrl: job.downloadUrl,
            claudeProgress: null,
            claudeCompleted: false,
            claudeStatusType: job.claudeDownloadUrl ? 'gray' : 'purple',
            claudeDownloadUrl: job.claudeDownloadUrl,
            claudeError: null
          };
        });

        setProjects(mappedProjects);
      } catch (err: any) {
        console.error("Failed to load jobs", err);
        setGlobalError("נכשל בטעינת הנתונים מהשרת.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const deleteProject = async (id: number): Promise<void> => {
    if (window.confirm('האם אתה בטוח שברצונך למחוק את השורה?')) {
      setProjects(projects.filter(project => project.id !== id));
      await JobService.deleteJob(id);
    }
  };

  const handleSaveNewJob = async (jobData: any) => {
    try {
      const payload: Job = {
        price: jobData.price,
        fileUpload: jobData.fileRecovery,
        id: -Date.now(),
        orderingCompanyId: jobData.OrderingCompany,
        propertyTypeId: 1,
        created: Date.now().toString(),
        downloadUrl :jobData.downloadUrl
      };

      const response = await JobService.addJob(payload);

      const savedJobFromServer: Project = {
        id: response.id,
        price: response.price.toString(),
        fileRecovery: response.fileUpload || "",
        OrderingCompany: response.orderingCompanyId?.toString() || '',
        workType: 'תכנון', // מומלץ להתאים לסוג שנבחר
        status: 'פתח קובץ',
        progress: null,
        completed: false,
        statusType: 'purple'
      };

      const updatedProjects = projects.map(project => 
        project.id === jobData.id ? savedJobFromServer : project
      );
      setProjects(updatedProjects);
      alert("העבודה נשמרה בהצלחה!");
    } catch (error) {
      console.error("שגיאה בשמירת העבודה:", error);
      alert("נכשל בשמירת העבודה");
    }
  };

  const updateProject = (id: number, field: keyof Project, value: any): void => {
    setProjects(projects.map(project => 
      project.id === id ? { ...project, [field]: value } : project
    ));
  };

  const handleSendToProcess = async (project: Project) => {
    if (!project.fileObject) {
      setProjects(prev => prev.map(p => p.id === project.id ? {
        ...p,
        error: 'אנא בחר קובץ PDF פיזי תחילה.',
        progress: null
      } : p));
      return;
    }

    setProjects(prev => prev.map(p => p.id === project.id ? {
      ...p,
      error: '',
      progress: 5,
      statusType: 'blue'
    } : p));

 // 🛠️ שינוי זמן הריצה של האינטרוול מ-400 ל-800 מילי-שניות (איטי יותר)
const progressInterval = setInterval(() => {
  setProjects(prev => prev.map(p => {
    // 🛠️ שינוי תנאי החסימה ל-99 כדי לאפשר לזה להגיע עד הסוף
    if (p.id === project.id && p.progress !== null && p.progress < 99) {
      
      let increment = 0;
      
      if (p.progress < 50) {
        // קצב התחלתי: 2-4 אחוזים
        increment = Math.floor(Math.random() * 3) + 2; 
      } else if (p.progress < 80) {
        // קצב אמצע: 1-2 אחוזים
        increment = Math.floor(Math.random() * 2) + 1;
      } else {
        // 🛠️ זחילה לקראת הסוף (מ-80% ועד 99%): 
        // כדי שזה לא יגיע ל-99 מהר מדי, נגריל סיכוי של 50% להתקדם באחוז אחד, 
        // וב-50% מהפעמים המספר יישאר קבוע באותו אינטרוול. זה יוצר תחושת "זחילה מתעכבת" אמיתית.
        increment = Math.random() > 0.5 ? 1 : 0;
      }

      const nextProgress = p.progress + increment;
      
      // הגבלה מקסימלית ל-99%
      return { ...p, progress: Math.min(nextProgress, 99) };
    }
    return p;
  }));
}, 800); // רץ כל 800 מילי-שניות

    try {
              console.log("PROJECT ID:", project.id);

      // אם זה קובץ קיים מהשרת ואין fileObject, אפשר להעביר לשרת לוגיקה מתאימה או את שם הקובץ
      const response = await MmdService.generateAndProcess(project.fileObject,project.id);
      clearInterval(progressInterval);

      if (response && response.success && response.downloadUrl) {
        setProjects(prev => prev.map(p => p.id === project.id ? {
          ...p,
          progress: 100,
          completed: true,
          statusType: 'gray',
          downloadUrl: response.downloadUrl
        } : p));
      } else {
        const serverMessage = response?.message || 'העיבוד נכשל ללא פירוט מהשרת.';
        setProjects(prev => prev.map(p => p.id === project.id ? {
          ...p,
          progress: null,
          statusType: 'gray',
          error: serverMessage
        } : p));
      }

    } catch (err: any) {
      clearInterval(progressInterval);
      let serverErrorMessage = 'אירעה שגיאה בתקשורת עם השרת.';
      if (err.response && err.response.data) {
        serverErrorMessage = err.response.data.message || err.response.data.error || serverErrorMessage;
      } else if (err.message) {
        serverErrorMessage = err.message;
      }
      setProjects(prev => prev.map(p => p.id === project.id ? {
        ...p,
        progress: null,
        statusType: 'gray',
        error: serverErrorMessage
      } : p));
    }
  };

    const handleSendToProcessClaude = async (project: Project) => {
    if (!project.fileObject) {
      setProjects(prev => prev.map(p => p.id === project.id ? {
        ...p,
        claudeError: 'אנא בחר קובץ PDF פיזי תחילה.',
        claudeProgress: null
      } : p));
      return;
    }

    setProjects(prev => prev.map(p => p.id === project.id ? {
      ...p,
      claudeError: '',
      claudeProgress: 5,
      claudeStatusType: 'blue'
    } : p));

    const progressInterval = setInterval(() => {
      setProjects(prev => prev.map(p => {
        if (p.id === project.id && p.claudeProgress !== null && p.claudeProgress !== undefined && p.claudeProgress < 99) {
          let increment = 0;
          if (p.claudeProgress < 50) {
            increment = Math.floor(Math.random() * 3) + 2;
          } else if (p.claudeProgress < 80) {
            increment = Math.floor(Math.random() * 2) + 1;
          } else {
            increment = Math.random() > 0.5 ? 1 : 0;
          }
          const nextProgress = p.claudeProgress + increment;
          return { ...p, claudeProgress: Math.min(nextProgress, 99) };
        }
        return p;
      }));
    }, 800);

    try {
      const response = await MmdService.generateAndProcessClaude(project.fileObject, project.id);
      clearInterval(progressInterval);

      if (response && response.success && response.downloadUrl) {
        setProjects(prev => prev.map(p => p.id === project.id ? {
          ...p,
          claudeProgress: 100,
          claudeCompleted: true,
          claudeStatusType: 'gray',
          claudeDownloadUrl: response.downloadUrl
        } : p));
      } else {
        const serverMessage = response?.message || 'העיבוד נכשל ללא פירוט מהשרת.';
        setProjects(prev => prev.map(p => p.id === project.id ? {
          ...p,
          claudeProgress: null,
          claudeStatusType: 'gray',
          claudeError: serverMessage
        } : p));
      }
    } catch (err: any) {
      clearInterval(progressInterval);
      let serverErrorMessage = 'אירעה שגיאה בתקשורת עם השרת.';
      if (err.response && err.response.data) {
        serverErrorMessage = err.response.data.message || err.response.data.error || serverErrorMessage;
      } else if (err.message) {
        serverErrorMessage = err.message;
      }
      setProjects(prev => prev.map(p => p.id === project.id ? {
        ...p,
        claudeProgress: null,
        claudeStatusType: 'gray',
        claudeError: serverErrorMessage
      } : p));
    }
  };  
  
  if (loading) return <div style={{ textAlign: 'center', padding: '20px' }}>טוען נתונים...</div>;
  if (globalError) return <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>{globalError}</div>;
  return (
  <>
    <main className="main-container">
      <div className="table-container">
        {projects.map((project) =>{
        console.log("ערך הלינק הנוכחי:", project.downloadUrl);

        return (
        
          <div key={project.id} className="table-row">
            
            {/* שם המזמין */}
          <div className="field">
            <label>שם המזמין</label>
            <select 
              // הוסר ה-disabled-look, משאירים רק פורמה רגילה ולבנה
              className="form-select"
              value={project.OrderingCompany} 
              onChange={(e) => updateProject(project.id, 'OrderingCompany', e.target.value)}
              // 🔒 חוסם פיזית כל אינטראקציה או פתיחה של התפריט ברשומות ישנות, אך משאיר רקע לבן
              style={!project.isNew ? { pointerEvents: 'none' } : {}} 
            >
              <option value=""></option>
              {businesses.map((business: any) => (
                <option key={business.id} value={business.id.toString()}>
                  {business.name}
                </option>
              ))}
            </select>
          </div>

            {/* סוג העבודה */}
        {/* סוג העבודה - תמיד שרטוט, תמיד לבן, נעול */}
          <div className="field">
            <label>סוג העבודה</label>
            <input 
              type="text"
              className="form-input" // 👈 הוסר ה-disabled-look
              value="שרטוט" 
              readOnly // 🔒 מונע הקלדה לחלוטין
            />
          </div>

            {/* מחיר */}
          <div className="field">
            <label>מחיר</label>
            <input 
              type="text" 
              className="form-input" // 👈 הוסר התנאי של disabled-look, תמיד לבן
              value={project.price}
              onChange={(e) => updateProject(project.id, 'price', e.target.value)}
              readOnly={!project.isNew} // 🔒 שומר על חסימת ההקלדה ברשומות ישנות
            />
          </div>

        {/* העלאת קובץ / הצגת קובץ */}
{!project.isNew ? (
  <div className="field">
    <label>קובץ מקור</label>
    <input
      type="file"
      id={`fileInput-${project.id}`}
      style={{ display: 'none' }}
      accept=".pdf"
      onChange={(e) => {
        if (e.target.files && e.target.files[0]) {
          const file = e.target.files[0];
          setProjects(prev => prev.map(p => 
            p.id === project.id ? { 
              ...p, 
              fileRecovery: file.name,
              fileObject: file,
              error: ''
            } : p
          ));
        }
      }}
    />
    
    {/* אם אין קובץ בכלל בשדה או שרשום "string" */}
    {(!project.fileRecovery || project.fileRecovery.toLowerCase() === "string") ? (
      <button
        type="button"
        className="form-input file-btn"
        onClick={() => document.getElementById(`fileInput-${project.id}`)?.click()}
      >
        לחץ להעלאת קובץ
      </button>
    ) : (
      /* אם יש קובץ - מציגים אותו כקישור להורדה פיזית */
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
<span
  onClick={async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PDFFILE_BASE_URL}${project.fileRecovery}`);
      if (!response.ok) throw new Error("נכשל במשיכת הקובץ מהשרת");
      const blob = await response.blob();
      const localUrl = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = localUrl;
      const cleanFileName = project.fileRecovery.split('/').pop()?.replace(/^\d+_[a-f0-9-]+_/, '') || 'document.pdf';
      tempLink.setAttribute('download', cleanFileName);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(localUrl);
    } catch (error) {
      console.error("שגיאה בהורדת הקובץ:", error);
      window.open(`${process.env.REACT_APP_PDFFILE_BASE_URL}${project.fileRecovery}`, '_blank');
    }
  }}
  className="form-input static-file-btn"
  style={{ 
    textDecoration: 'underline', 
    color: '#7B2CBF', 
    cursor: 'pointer', 
    
    // --- התיקון העיצובי להתאמה מושלמת לשאר השורות ---
    display: 'block',             // הופך לבלוק מלא שמתפרס כמו ה-input-ים האחרים
    width: '85%',                // תופס את כל רוחב התיבה המקורית שלו
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',         // מונע מהטקסט לרדת שורה
    overflow: 'hidden',           // מסתיר חריגות
    textOverflow: 'ellipsis',     // מוסיף שלוש נקודות בסוף
    
    // הגדרות המרחב והגובה המקוריות שלך מהקלאס או הסטייל
    textAlign: 'center',
    lineHeight: '2.4',
    padding: '3px 12px'             // מעניק מרווח פנימי קטן מהצדדים כדי שהשלוש נקודות לא יידבקו למסגרת
  }}
  title={project.fileRecovery.split('/').pop()?.replace(/^\d+_[a-f0-9-]+_/, '')}
>
  {project.fileRecovery.split('/').pop()?.replace(/^\d+_[a-f0-9-]+_/, '')}
</span>
        
        {/* כפתור קטן אופציונלי המאפשר להחליף קובץ במידת הצורך במידה ולא התחיל עיבוד */}
        {project.progress === null && !project.completed && !project.downloadUrl && (
          <span 
            onClick={() => document.getElementById(`fileInput-${project.id}`)?.click()}
            style={{ fontSize: '11px', color: '#888', cursor: 'pointer', textAlign: 'center', textDecoration: 'underline' }}
          >
            החלף קובץ
          </span>
        )}
      </div>
    )}
  </div>
) : (
  <div className="field"></div>
)}
                      {/* כפתור שליחה לביצוע, שגיאה, וכפתור הורדה משותף */}
              {/* כפתור שליחה לביצוע, שגיאה, וכפתור הורדה משותף */}
              <div className="field action-wrapper" style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {!project.isNew && (
            <button 
              onClick={() => handleSendToProcess(project)}
              disabled={project.progress !== null || project.completed || !!project.downloadUrl}
              className={`status-btn ${project.statusType} btn-execute btn-wide`}
            >
              {project.progress !== null && project.progress < 100 
                ? `מעבד... ${project.progress}%` 
                : (project.completed || project.downloadUrl) ? 'הסתיים' : 'שלח לביצוע ב-Gemini'}
            </button>
          )}

          {(project.completed || project.downloadUrl) && project.downloadUrl && (
            <a 
              href={project.downloadUrl} 
              download={`Mamad_Plan_${project.id}.dwg`}
              className="status-btn purple download-link"
              style={{ textDecoration: 'none', display: 'inline-block', textAlign: 'center', margin: 0 }}
            >
              הורדה
            </a>
          )}

          {!project.isNew && (
            <button 
              onClick={() => handleSendToProcessClaude(project)}
              disabled={project.claudeProgress !== null || project.claudeCompleted || !!project.claudeDownloadUrl}
              className={`status-btn ${(project.claudeCompleted || project.claudeDownloadUrl) ? 'claude-gray' : (project.claudeProgress !== null ? 'claude-blue' : 'claude-purple')} btn-execute btn-wide`}
            >
              {project.claudeProgress !== null && project.claudeProgress !== undefined && project.claudeProgress < 100 
                ? `מעבד... ${project.claudeProgress}%` 
                : (project.claudeCompleted || project.claudeDownloadUrl) ? 'הסתיים' : 'שלח לביצוע ב-Claude'}
            </button>
          )}

          {(project.claudeCompleted || project.claudeDownloadUrl) && project.claudeDownloadUrl && (
            <a 
    href={project.claudeDownloadUrl}
    download={`Mamad_Plan_Claude_${project.id}.json`}
    className="status-btn claude-blue download-link"
    style={{ textDecoration: 'none', display: 'inline-block', textAlign: 'center', margin: 0 }}
  >
    הורדה
  </a>
)}

          {project.error && (
            <span className="row-error-inline" title={project.error}>
              <button 
                onClick={() => navigator.clipboard.writeText(project.error ?? "")}
                style={{ marginRight: '8px', cursor: 'pointer' }}>
                📋 העתק שגיאה
              </button>
              {project.error}
            </span>
          )}

          {project.claudeError && (
            <span className="row-error-inline" title={project.claudeError}>
              <button 
                onClick={() => navigator.clipboard.writeText(project.claudeError ?? "")}
                style={{ marginRight: '8px', cursor: 'pointer' }}>
                📋 העתק שגיאה
              </button>
              {project.claudeError}
            </span>
          )}
        </div>
            <div className="field delete-field">
              {project.isNew ? (
                <button 
                  onClick={() => handleSaveNewJob(project)} 
                  className="status-btn purple btn-execute"
                  style={{ padding: '6px 12px', cursor: 'pointer' }}
                >
                  שמור
                </button>
              ) : (
                <button 
                  className="delete-btn"
                  onClick={() => deleteProject(project.id)}
                  aria-label="מחק שורה"
                >
                  <img src={deleteIcon} alt="Delete" width={34} height={34} />
                </button>
              )}
            </div>

          </div>
        )})}
      </div>
    </main>
  </>
);
};

export default JobsList;